import React, { useState } from "react";
import {
  StyledInput,
  StyledButton,
  Label,
  ErrorMessage,
} from "./StyledComponents";

function LoyaltyForm({
  inputValue,
  availableAmount,
  handleInputChange,
  handleSubmit,
  serverError,
  isSubmitting,
}) {
  const [error, setError] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    if (!Number(inputValue) || Number(inputValue) < 0) {
      setError("Please enter a valid redemption amount");
      return;
    }
    if (Number(inputValue) > availableAmount) {
      setError(`You can’t redeem more than ${availableAmount}.`);
      return;
    }

    setError(""); // clear any previous validation error
    handleSubmit(e);
  };

  const onChange = (e) => {
    const val = e.target.value;
    if (Number(val) > availableAmount) {
      e.target.value = availableAmount;
      setError(`You can’t redeem more than ${availableAmount}.`);
      return;
    }
    setError("");
    handleInputChange(e);
  };

  return (
    <form onSubmit={onSubmit}>
      <Label htmlFor="redeem-amount">Enter amount to redeem</Label>
      <StyledInput
        type="number"
        id="redeem-amount"
        placeholder={`(e.g., up to ${availableAmount})`}
        value={inputValue}
        onChange={onChange}
        max={availableAmount}
        disabled={isSubmitting}
      />
      <StyledButton type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Please wait…" : "Use Coupon"}
      </StyledButton>

      {/* Validation error */}
      {error && <ErrorMessage>{error}</ErrorMessage>}

      {/* Server‐side error */}
      {serverError && <ErrorMessage>{serverError}</ErrorMessage>}
    </form>
  );
}

export default LoyaltyForm;
